import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';

const SecondShare = () => {
    const qqShareConfig = {
        title: '鳳凰衛視“發現新主播”社會招募行動開啓',
        img: 'https://d.ifengimg.com/w300_h300_q90/x0.ifengimg.com/ucms/2024_29/7533C3861CF9F2DE9724A9783FEE0F0D271A4264_size1572_w1080_h1080.png',
        desc: '想成為鳳凰衛視主持人、評論員、主播、出鏡記者就快來報名參加吧！',
        appType: 'newsApp',
        cb: () => {},
    };

    return qqShareConfig?.title ? <QQShare content={qqShareConfig} /> : null;
};

export default errorBoundary(SecondShare);
